import { Loader2 } from "lucide-react";
import type { AsyncTask } from "@/modern/components/async-tasks/types";
import { getTaskStatusMessage } from "@/modern/components/async-tasks/utils";

/** List-row skeleton for Coverage "Generated Work Files" panel — driven by AsyncTaskUI.Loader. */
export function WorkFileGeneratingListRow({ task }: { task?: AsyncTask }) {
  const label = task ? getTaskStatusMessage(task) : "Generating work file…";

  return (
    <div
      className="flex flex-col gap-2 border-b border-primary/20 bg-primary/5 px-4 py-3"
      aria-busy
      aria-label={label}
    >
      <div className="flex items-center gap-2">
        <Loader2 className="size-3.5 shrink-0 animate-spin text-primary/70" aria-hidden />
        <span className="text-sm font-medium text-foreground/85">{label}</span>
      </div>
      <div className="space-y-1.5 pl-5">
        <div className="h-2 max-w-[200px] w-[80%] animate-pulse rounded bg-muted" />
        <div className="h-2 max-w-[140px] w-[60%] animate-pulse rounded bg-muted/70" />
      </div>
    </div>
  );
}

/** Card skeleton for Work Files grid — driven by AsyncTaskUI.Loader. */
export function WorkFileGeneratingCard({ task }: { task?: AsyncTask }) {
  const label = task ? getTaskStatusMessage(task) : "Generating work file…";

  return (
    <article
      className="flex flex-col overflow-hidden rounded-xl border border-dashed border-primary/30 bg-card/60 shadow-sm"
      aria-busy
      aria-label={label}
    >
      <div className="flex flex-1 flex-col gap-3 p-4">
        <div className="flex items-center gap-2">
          <Loader2 className="size-4 shrink-0 animate-spin text-primary/70" aria-hidden />
          <span className="text-xs font-medium text-muted-foreground">{label}</span>
        </div>
        <div className="h-4 w-[66%] animate-pulse rounded-md bg-muted" />
        <div className="space-y-1.5">
          <div className="h-2 w-full animate-pulse rounded bg-muted/80" />
          <div className="h-2 w-[80%] animate-pulse rounded bg-muted/60" />
        </div>
        <div className="mt-1 grid grid-cols-3 gap-1.5">
          {[0, 1, 2].map((i) => (
            <div key={i} className="aspect-square animate-pulse rounded-md bg-muted/50" />
          ))}
        </div>
      </div>
      <div className="flex items-center gap-2 border-t border-border/50 px-4 py-2.5">
        <div className="h-2 w-12 animate-pulse rounded bg-muted/50" />
        <div className="h-2 w-16 animate-pulse rounded bg-muted/40" />
      </div>
    </article>
  );
}
